import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';

import {
  RenderField,
  Toggle,
  ButtonV2,
} from '@zola/zola-ui';

// Utils
import EventTypes from '../../events/util/EventTypes';
import * as Validations from '../../../common/form/commonValidations';

// Components
import {
  RenderDatePicker,
  RenderGeosuggest,
  RenderTimePicker,
} from '../../../common/form';
import { RenderDropdownSelectV2 } from '../../../common/form/indexV2';
import AddressFields from '../../../common/form/AddressFields';
import Loader from '../../../common/ui/Loader';
import EventFormOtherDetails from './EventFormOtherDetails';
import EventFormSuggestions from './EventFormSuggestions';
import LabelWithActionLink from './LabelWithActionLink';

// Styles
import './EventFormV2.less';

class EventForm extends Component {
  constructor(props) {
    super(props);

    this.toggleAddress = this.toggleAddress.bind(this);
    this.resetAddress = this.resetAddress.bind(this);
    this.prefillEventName = this.prefillEventName.bind(this);

    this.state = {
      autoAddress: true,
    };
  }

  componentWillMount() {
    const { initialValues } = this.props;
    if (initialValues.venueName || initialValues.city || initialValues.state_province || initialValues.address_1 || initialValues.address_2) {
      this.setState({
        autoAddress: false
      });
    }
  }

  componentDidMount() {
    const { getSuggestedAttireOptions, getRsvpSuggestions  } = this.props;

    getSuggestedAttireOptions();
    getRsvpSuggestions();
  }

  componentWillReceiveProps(nextProps) {
    const { address, handleAddress } = this.props;
    if (_.keys(nextProps.address).length > 0 && nextProps.address !== address && !nextProps.address.busy) {
      handleAddress(nextProps.address);
    }
  }

  componentWillUnmount() {
    const { onSelectEvent } = this.props;
    onSelectEvent(null);
    this.resetAddress();
  }

  getEventNameByType(type) {
    const eventType = EventTypes.find(obj => obj.value === type);
    return eventType ? eventType.title : null;
  }

  toggleAddress() {
    this.setState(state => ({ autoAddress: !state.autoAddress }));
  }

  resetAddress() {
    const { address, onResetAddress } = this.props;
    if (address.google_place_id) {
      onResetAddress(address);
      this.setState({
        autoAddress: true
      });
    }
  }

  prefillEventName(type, name) {
    const { setEventName } = this.props;
    const eventName = this.getEventNameByType(type);

    if (!name && eventName) setEventName(eventName);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      getSuggestion,
      address,
      rsvpSuggestions,
      suggestedAttireOptions,
      onResetAddressSearch,
      formValues,
      onToggleCommonQs,
      onToggleAttireOs,
      onToggleOtherDetails,
      showOtherDetails,
      isAttire,
      isCommonQs,
      setAttire,
      setQuestion,
      numberOfEvents,
      numberOfGuests,
      selectedId,
    } = this.props;

    let addressLabel = <LabelWithActionLink label="Event Location" actionFunc={this.toggleAddress} actionName="Enter Address Manually" />;
    let submitButtonText = selectedId ? 'Save' : 'Add Event';

    if (!this.state.autoAddress) {
      const actionName = address.google_place_id ? 'Reset Address' : 'Search For Location';
      const actionFunc = address.google_place_id ? this.resetAddress : this.toggleAddress;
      addressLabel = <LabelWithActionLink label="Venue Name" actionFunc={actionFunc} actionName={actionName} />;
    }

    if (numberOfEvents === 0 && numberOfGuests === 0) {
      submitButtonText = 'Next: Add Guests';
    }

    return (
      <div className="event-form-container">
        {(isAttire || isCommonQs) ? (
          <EventFormSuggestions
            isAttire={isAttire}
            isCommonQs={isCommonQs}
            onToggleCommonQs={onToggleCommonQs}
            onToggleAttireOs={onToggleAttireOs}
            setAttire={setAttire}
            setQuestion={setQuestion}
            rsvpSuggestions={rsvpSuggestions}
            suggestedAttireOptions={suggestedAttireOptions}
          />
        ) : (
        <form onSubmit={handleSubmit} id="event-form" className="event-form" noValidate>
          <div className="event-form__basic-details">
            <div className="row">
              <div className="col-sm-4">
                <Field
                  component={RenderDropdownSelectV2}
                  name="type"
                  options={EventTypes}
                  id="event-type-2"
                  label="Event Type"
                  required
                  validate={Validations.REQUIRED}
                  onChange={(_e, newValue) => this.prefillEventName(newValue, formValues.name)}
                />
              </div>
              <div className="col-sm-8">
                <Field
                  component={RenderField}
                  name="name"
                  label="Event Name"
                  type="text"
                  id="event-name"
                  placeholder="Our Ceremony"
                  required
                  maxChars={100}
                  validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <Field
                  component={RenderDatePicker}
                  name="date"
                  label="Date"
                  id="event-date"
                  datePickerOptions={{ disabledDays: { before: new Date() } }}
                  required
                  validate={[Validations.REQUIRED, Validations.DATE, Validations.DATE_AFTER_NOW]}
                />
              </div>
              <div className="col-sm-3">
                <Field
                  component={RenderTimePicker}
                  name="start_at"
                  id="event-start-time"
                  label="Start Time"
                  required
                  validate={Validations.REQUIRED}
                />
              </div>
              <div className="col-sm-3">
                <Field
                  component={RenderTimePicker}
                  name="end_at"
                  id="event-end-time"
                  label="End Time"
                />
              </div>
            </div>
            {this.state.autoAddress && !address.busy && (
              <div className="form-group venue-name">
                <Field
                  name="venue_name"
                  label={addressLabel}
                  id="event-venue-address"
                  placeholder="Brooklyn Winery"
                  validate={Validations.MAX_LENGTH_50}
                  maxChars={50}
                  component={RenderGeosuggest}
                  onSuggestSelect={(suggestion) => {
                    if (!suggestion) return;

                    getSuggestion(suggestion)
                      .then(() => this.toggleAddress())
                      .catch(() => onResetAddressSearch());
                  }}
                  inputClassName="form-control"
                  hideFormGroup
                />
              </div>
            )}
            {!this.state.autoAddress && !address.busy && (
              <div className="event-address">
                <div className="form-group venue-name">
                  <Field
                    component={RenderField}
                    type="text"
                    label={addressLabel}
                    id="event-venue-name"
                    name="venue_name"
                    validate={Validations.MAX_LENGTH_50}
                    maxChars={50}
                    hideFormGroup
                  />
                </div>
                <AddressFields selector="eventForm" minimal optional />
              </div>
            )}
            {address.busy && <Loader />}
            <div className="website-settings">
              <div className="website-settings__label form__label">Event Settings on Website</div>
              <div className="website-settings__options">
                <Field
                  name="public"
                  id="is-public"
                  label="Make event public to all guests"
                  component={Toggle}
                  className="website-settings__toggle"
                  inline
                />
                <Field
                  name="collect_rsvps"
                  id="collect-rsvps"
                  label="Let guests RSVP on website"
                  component={Toggle}
                  className="website-settings__toggle"
                  inline
                />
              </div>
            </div>
          </div>
          <EventFormOtherDetails
            onToggleCommonQs={onToggleCommonQs}
            onToggleAttireOs={onToggleAttireOs}
            onToggleOtherDetails={onToggleOtherDetails}
            showOtherDetails={showOtherDetails}
          />
          <div className="event-form__submit-section">
            <ButtonV2 type="submit" disabled={!valid || submitting}>
              { submitButtonText }
            </ButtonV2>
          </div>
        </form>
        )}
      </div>
    );
  }
}

EventForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    venue_name: PropTypes.string
  }),
  getSuggestion: PropTypes.func,
  address: PropTypes.shape({
    busy: PropTypes.bool
  }),
  handleAddress: PropTypes.func,
  onResetAddress: PropTypes.func,
  onSelectEvent: PropTypes.func,
  onToggleCommonQs: PropTypes.func,
  onToggleAttireOs: PropTypes.func,
  onResetAddressSearch: PropTypes.func,
};

export default EventForm;



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/EventFormV2.jsx